import React, { useState, useEffect } from 'react';
import { StyleSheet, Text, View, TextInput, TouchableOpacity, ScrollView, Dimensions, ActivityIndicator, Modal, Button } from 'react-native';
import { Ionicons } from '@expo/vector-icons'; // Import icons from Expo
import BouncyCheckbox from "react-native-bouncy-checkbox";
import { useDispatch } from 'react-redux';
import { setUser } from '../redux/userSlice';
// import logo from '/assets/images/votre-logo-ici.png';
// import GoogleSignInButton from './GoogleSignInButton';
// import { ScrollView } from 'react-native-gesture-handler';

export default function SignUp({onSignUp}) {
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState(''); // New state for confirmation password
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] = useState(false);
    const [isPolicyAccepted, setPolicyAccepted] = useState(false);
    const [isLoading, setIsLoading] = useState(false); // New state variable for loading status
    const [fontSize, setFontSize] = useState(16); // Initial font size
    const { width: screenWidth } = Dimensions.get('window');
    const handlePress = () => setTermsVisible(true);
    const logo = require('../assets/ipf_logo.png');
    const [isTermsVisible, setTermsVisible] = useState(false);

    const dispatch = useDispatch();

    const validatePassword = (password) => {
        // At least 8 chars
        // Contains at least one digit
        // Contains at least one lower alpha char and one upper alpha char
        // Contains at least one char within a set of special chars (@#%$^ etc.)
        const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
        return re.test(password);
    };

    const handleSignUp = async () => {
        setIsLoading(true);
        try {
            if (!firstName || firstName.length < 2) {
                alert('Please enter a valid first name');
                return;
            } else if (!lastName || lastName.length < 2) {
                alert('Please enter a valid last name');
                return;
            } else if (!email || !email.includes('@')) {
                alert('Please enter a valid email');
                return;
            } else if (password !== confirmPassword) {
                alert("Passwords do not match");
                return;
            } else if (!validatePassword(password)) {
                alert("Password must be at least 8 characters, include at least 1 digit, 1 lowercase letter, 1 uppercase letter, and 1 special character.");
                return;
            } else if (!isPolicyAccepted) {
                alert('Please accept the terms and conditions before signing up.');
                return;
            } else {
                const userData =  await createUser();
                const {firebase_id, id, nom, prenom, username} = userData;
                if (userData !== undefined) {
                    dispatch(setUser({firebase_id, id, lastName: nom, firstName: prenom, email: username}));
                }
            }
        } catch (error) {
            console.error('Error during sign up:', error);
        } finally {
            setIsLoading(false);
        }
    };

    //Post request to backend to create user http://localhost:3010/api/profil
    // Paramètres IN : email, lastName, firstName, password
    const createUser = async () => {
        try {
            const response = await fetch('https://pickleball-rules-app-backend.onrender.com/api/profil', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    lastName: lastName,
                    firstName: firstName,
                    email: email,
                    password: password,
                }),
            });
            if (!response.ok) {
                const errorData = await response.json();
                if (errorData.code.includes('auth/email-already-exists')) {
                    alert('The email address is already in use by another account.');
                    return;
                }
                throw new Error('Something went wrong!');
            }
            const data = await response.json();
            const {isAuthenticated, profil} = data;
            return profil;
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const confirmPasswordHandler = (value) => {
        setConfirmPassword(value);
    };

    useEffect(() => {
        // Calculate the font size based on screen width
        const newFontSize = Math.max(12, screenWidth / 190);
        setFontSize(newFontSize);
    }, [screenWidth]);


    let termsOfService = `
    Last Modified: March 17, 2024
    
    • Acceptance of the Terms of Use
    
    These terms of use ("Terms of Use") are a legally binding agreement between you ("User," "you," or "your") and Swift Coders ("Company," "we," "us," or "our"). These Terms govern your access to and use of the Rules of Pickleball website https://pbrulebook.com, including any content, features, and services offered on or through https://pbrulebook.com (the"Website"). By accessing or using the website, you agree to be bound by these Terms. If you do not agree with all of these Terms, you must not access or use the Website.
    
    • Age Requirement
    
    The Website is intended for individuals who are 13 years of age or older. By accessing or using the Website, you represent and warrant that you are at least 13 years old and have the legal capacity to enter into these Terms. If you are under 13 years old, you may not access or use the Website.
    
    • Changes to the Terms of Use
    
    We reserve the right to modify or replace these Terms at any time. The date of the last revision will be updated accordingly. It is your responsibility to review these Terms periodically for changes. Your continued use of the Website after any revisions to these Terms constitutes acceptance of those changes.
    
    • Accessing the Website and Account Security
    
    We reserve the right to withdraw or amend the Website, and any service or material we provide on the Website, in our sole discretion without notice. We will not be liable if for any reason all or any part of the Website is unavailable at any time or for any period. From time to time, we may restrict access to some parts of the Website, or the entire Website, to users, including registered users.
    
    You are responsible for ensuring that all persons who access the Website through your internet connection are aware of these Terms and comply with them. If you choose, or are provided with, a username, password, or any other piece of information as part of our security procedures, you must treat such information as confidential. You must not disclose it to any third party. We have the right to disable any username, password, or other identifier, whether chosen by you or provided by us, at any time if, in our opinion, you have violated any provision of these Terms.
    
    • Intellectual Property Rights
    
    The Website and its entire contents, features, and functionality are owned by Swift Coders or its licensors and are protected by copyright, trademark, and other laws. These Terms permit you to use the Website for your personal, non-commercial use only. You must not reproduce, distribute, modify, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our Website, except as expressly permitted.
    
    • Prohibited Uses
    
    You agree not to use the Website:
    
    In any way that violates any applicable federal, state, local, or international law or regulation.
    To impersonate or attempt to impersonate Swift Coders, a Company employee, another user, or any other person or entity.
    To engage in any other conduct that restricts or inhibits anyone's use or enjoyment of the Website.

    • User Contributions
    
    The Website may contain interactive features that allow users to post, submit, publish, display, or transmit content or materials on or through the Website ("User Contributions"). All User Contributions must comply with the content standards set out in these Terms.
    
    By providing any User Contributions, you grant us and our affiliates a perpetual, irrevocable, worldwide, royalty-free, sublicensable, and transferable license to use, reproduce, distribute, modify, adapt, publicly perform, publicly display, transmit, stream, broadcast, and otherwise exploit such User Contributions.
    
    • Monitoring and Enforcement; Termination
    
    We have the right to:
    
    Remove or refuse to post any User Contributions for any reason in our sole discretion.
    Take appropriate legal action, including referral to law enforcement, for any illegal or unauthorized use of the Website.

    • Disclaimer of Warranties
    
    The Website and its content are provided on an "as is" and "as available" basis, without any warranties of any kind.
    
    • Limitation of Liability
    
    In no event will Swift Coders, its affiliates, or their licensors, service providers, employees, agents, officers, or directors be liable for damages of any kind.
    
    • Indemnification
    
    You agree to indemnify, defend, and hold harmless Swift Coders and its affiliates, licensors, and service providers from any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees arising out of or relating to your violation of these Terms.
    
    • Governing Law and Jurisdiction
    
    These Terms and any dispute or claim arising out of or related to them or the Website will be governed by and construed in accordance with the laws of Canada, without regard to its conflict of law provisions.
    
    • Contact Us
    
    If you have any questions about these Terms, please contact us at admin@swiftcoders.ca
    
    `;

    return ( 
        <ScrollView style={styles.container}>
            <View style={{ alignSelf: 'center', justifyContent: 'center' }}>
                <Text style={styles.title}>Sign Up</Text>
                {/* <Text style={styles.text}></Text> */}
                <View style={styles.inputContainer}>
                    <View style={styles.inputWrapper}>
                        <Ionicons name="person" size={24} color="#000" style={styles.icon} />
                        <TextInput
                            style={styles.input}
                            placeholder="First name"
                            onChangeText={(value) => setFirstName(value)}
                            value={firstName}
                            placeholderTextColor="#7E7E7E"
                        />
                    </View>
                    <View style={styles.inputWrapper}>
                        <Ionicons name="person" size={24} color="#000" style={styles.icon} />
                        <TextInput
                            style={styles.input}
                            placeholder="Last name"
                            onChangeText={(value) => setLastName(value)}
                            value={lastName}
                            placeholderTextColor="#7E7E7E"
                        />
                    </View>
                    <View style={styles.inputWrapper}>
                        <Ionicons name="mail" size={24} color="#000" style={styles.icon} />
                        <TextInput
                            style={styles.input}
                            placeholder="Email"
                            onChangeText={(value) => setEmail(value)}
                            value={email}
                            placeholderTextColor="#7E7E7E"
                        />
                    </View>
                    <View style={styles.inputWrapper}>
                        <Ionicons name="lock-closed" size={24} color="#000" style={styles.icon} />
                        <TextInput
                            style={styles.input}
                            placeholder="Password"
                            secureTextEntry={!isPasswordVisible}
                            onChangeText={(value) => setPassword(value)}
                            value={password}
                            placeholderTextColor="#7E7E7E"
                        />
                        <Ionicons
                            style={styles.icon}
                            name={isPasswordVisible ? 'eye-off' : 'eye'}
                            size={24}
                            color="gray"
                            onPress={() => setIsPasswordVisible(!isPasswordVisible)}
                        />
                    </View>
                    <View style={styles.inputWrapper}>
                        <Ionicons name="lock-closed" size={24} color="#000" style={styles.icon} />
                        <TextInput
                            style={styles.input}
                            placeholder="Confirm password"
                            secureTextEntry={!isConfirmPasswordVisible}
                            onChangeText={confirmPasswordHandler}
                            value={confirmPassword}
                            placeholderTextColor="#7E7E7E"
                        />
                        <Ionicons
                            style={styles.icon}
                            name={isConfirmPasswordVisible ? 'eye-off' : 'eye'}
                            size={24}
                            color="gray"
                            onPress={() => setIsConfirmPasswordVisible(!isConfirmPasswordVisible)}
                        />
                    </View>
                    <View style={styles.policyContainer}>
                        {/* <CheckBox
                        value={isPolicyAccepted}
                        onValueChange={setPolicyAccepted}
                        /> */}
                        <BouncyCheckbox
                            size={14}
                            fillColor="#683267"
                            unfillColor="white"
                            iconStyle={{ borderColor: "#683267" }}
                            innerIconStyle={{ borderWidth: 2.5 }}
                            onPress={ () => {
                                setPolicyAccepted(prevState => !prevState);
                            }}
                            isChecked={isPolicyAccepted}
                        />
                        <Text style={styles.termsOfServiceText}>
                            I have read and agree to the<Text onPress={handlePress}> Terms of Service</Text>.
                        </Text>
                    </View>
                </View>
                <TouchableOpacity style={styles.button} onPress={handleSignUp} disabled={isLoading}>
                    {isLoading ? <ActivityIndicator size="small" color="#fff" /> : <Text style={[styles.buttonText, { fontSize: fontSize + 2 }]}>Sign Up</Text>}
                </TouchableOpacity>
                <View style={{ borderBottomColor: '#7E7E7E', borderBottomWidth: 1.5, alignSelf: 'center', width: '12%', marginVertical: 10 }} />
                {/* <GoogleSignInButton onPress={() => googleSignIn()} /> */}
                <TouchableOpacity style={styles.loginButton} onPress={onSignUp}>
                    <Text style={[styles.buttonText, { fontSize: fontSize + 2   }]}>Sign In</Text>
                </TouchableOpacity>
                <Modal
                    animationType="slide"
                    // transparent={true}
                    visible={isTermsVisible}
                    borderColor={'#653463'}
                    borderWidth={3}
                    overflow={'hidden'}
                    onRequestClose={() => { setTermsVisible(false); }}>
                        <View 
                            style={{
                                flex: 1,
                                justifyContent: 'center',
                                alignItems: 'center',
                                backgroundColor: '#683267',
                            }}
                        >
                            <View style={styles.termsModal}>
                                <Text>Terms of Service</Text>
                                <ScrollView>
                                    <Text>{termsOfService}</Text>
                                </ScrollView>
                                <TouchableOpacity title="Close" onPress={() => setTermsVisible(false)} style={styles.button}>
                                    <Text style={styles.buttonText}>Close</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                </Modal>
            </View>
        </ScrollView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fffaeb',
    },
    inputContainer: {
        minWidth: "85%",
        maxWidth: "90%",
        marginTop: 20,
        alignSelf: 'center',
        justifyContent: 'center',
    },
    title: {
        fontSize: 28,
        fontWeight: 'bold',
        marginBottom: 40,
        marginTop: 50,
        alignSelf: 'center',
        justifyContent: 'center',
    },
    text: {
        fontSize: 16,
        marginBottom: 20,
        marginHorizontal: 20,
        textAlign: 'center',
        color: '#7E7E7E',
        alignSelf: 'center',
        justifyContent: 'center',
    },
    subtitle: {
        fontSize: 18,
        marginBottom: 40,
        color: '#7E7E7E',
    },
    inputWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomWidth: 1,
        borderBottomColor: '#7E7E7E',
        marginBottom: 20,
        elevation: 2,
        shadowColor: 'rgba(0,0,0,0.2)',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        padding: 1,
    },
    icon: {
        marginRight: 10,
        color: '#7E7E7E',
        padding: 5,
    },
    policyContainer: {
        width: '90%',
        flexDirection: 'row',
        alignSelf: 'center',
        justifyContent: 'center',
        marginVertical: 10,
    },
    termsOfServiceText: {
        fontSize: 14,
        width: '80%',
    },
    termsModal: {
        width: '40%',
        // height: '90%',
        minWidth: 340,
        minHeight: 450,
        maxHeight: 630,
        backgroundColor: '#fffaeb',
        borderRadius: 20,
        overflow: 'hidden',
        padding: 20,
    },
    input: {
        flex: 1,
        fontSize: 18,
        color: '#000',
        padding: 5,
        overflow: 'hidden',
    },
    checkboxContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: 20,
    },
    checkbox: {
        marginRight: 5,
    },
    checkboxText: {
        fontSize: 18,
        marginLeft: 8,
    },
    button: {
        minWidth: "60%",
        width: '60%',
        height: 25,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#794a78',
        paddingHorizontal: 3,
        borderRadius: 5,
        elevation: 2,
        shadowColor: 'rgba(0,0,0,0.2)',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        alignSelf: 'center',
        justifyContent: 'center',
        marginTop: 20,
    },
    loginButton: {
        minWidth: "60%",
        width: '60%',
        height: 25,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#794a78',
        paddingHorizontal: 3,
        borderRadius: 5,
        elevation: 2,
        shadowColor: 'rgba(0,0,0,0.2)',
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.8,
        shadowRadius: 2,
        alignSelf: 'center',
        justifyContent: 'center',
        marginBottom: 40,
    },
    buttonText: {
        color: '#fff',
        fontWeight: 'bold',
        textAlign: 'center',
        maxHeight: 40,
        overflow: 'hidden',
        paddingVertical: 3,
    },
});